module.exports = {
  "id": "pin in place",
  "color": "purple",
  "title": "pin to piece",
  "icon": "pushpin",
  "category": "style",
  "exposedVariables": [
    {
      "tooltip":"Set which piece this piece is stuck to.",
      "value": "none",
      "variableName": "pinned to",
      "spriteName": "$glitch_target",
      "input": {
        "type": "sprite",
        "id": "pinned-to-sprite-selector"
      }
    },
    {
      "tooltip": "Set the horizontal offset of this piece from the pinned piece",
      "value": "0",
      "variableName": "Offset X",
      "spriteName": "$glitch_target",
      "input": {
        "type": "slider",
        "step": 1,
        "min": -100,
        "max": 100,
        "id": "offset-x-slider"
      }
    },
    {
      "tooltip": "Set the vertical offset of this piece from the pinned piece",
      "value": "0",
      "variableName": "Offset Y",
      "spriteName": "$glitch_target",
      "input": {
        "type": "slider",
        "step": 1,
        "min": -100,
        "max": 100,
        "id": "offset-y-slider"
      }
    }
  ],
  "info": [
    {
      "text": "Pin a piece so it sticks to another piece",
      "image": "provision/glitches/pin in place/pin in place.gif"
    }
  ],
  "codeImage": "provision/glitches/pin in place/pin in place.png",
  "code": null,
  "zip": null,
  "sb3": null,
  "image": "provision/parts/pin in place/pin in place.svg"
};